import {
  PouzivatelskaSkupinaSubjekt as PouzivatelskaSkupinaSubjektGenerated,
  RemoveSubjektBezPripomienokApi,
  SubjektBezPripomienokListApi,
  SubjektBezPripomienokListPage as SubjektBezPripomienokListPageGenerated,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import PouzivatelskaSkupinaSubjekt
  from '../model/subjektbezpripomienok/PouzivatelskaSkupinaSubjekt';
import SubjektBezPripomienokListPage
  from '../model/subjektbezpripomienok/SubjektBezPripomienokListPage';
import Uuid from '../model/Uuid';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new SubjektBezPripomienokListApi(apiConfiguration(pripomienkyPrefixPath));
const removeClient = new RemoveSubjektBezPripomienokApi(apiConfiguration(pripomienkyPrefixPath));

const mapSubjektItem = (generated: PouzivatelskaSkupinaSubjektGenerated): PouzivatelskaSkupinaSubjekt => ({
  uuid: generated.uuid,
  kratkeMeno: generated.kratkeMeno,
  popis: generated.popis,
});

const map = (data: SubjektBezPripomienokListPageGenerated): SubjektBezPripomienokListPage => ({
  subjekty: data.subjektBezPripomienokList.map(subjekt => mapSubjektItem(subjekt)),
  totalElements: data.totalElements,
  number: data.number,
  size: data.size,
});

export const removeSubjektBezPripomienok = async (
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  options?: AxiosRequestConfig,
)
    : Promise<ClientResponse<void>> => {
  const { status } = await removeClient.removeSubjektBezPripomienok(type, year, index, uuid, options);

  return { responseCode: status };
};

// eslint-disable-next-line import/prefer-default-export
export const fetchSubjektBezPripomienokListPage = async (
  type: string,
  year: number,
  index: number,
  page?: number,
  options?: AxiosRequestConfig,
):
    Promise<ClientResponse<SubjektBezPripomienokListPage>> => {
  const {
    data,
    status,
  } = await client.getSubjektBezPripomienokList(type, year, index, page, options);
  return {
    data: map(data), responseCode: status,
  };
};
